import type { ChangeEvent, HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { useCallback } from 'react';
import Checkbox from '__components/Checkbox/Checkbox';
import useFlashState from 'hooks/useFlashState';

interface SetAllCheckboxProps extends HTMLAttributes<HTMLDivElement> {
  disabled?: boolean;
  onChange(event: ChangeEvent<HTMLInputElement>): void;
}

export const SetAllCheckbox = styled(
  ({ disabled = false, onChange, ...rest }: SetAllCheckboxProps) => {
    const [checked, setChecked] = useFlashState(150, false);

    const handleChange = useCallback(
      (ev: ChangeEvent<HTMLInputElement>) => {
        onChange(ev);
        setChecked(ev.target.checked);
      },
      [setChecked, onChange]
    );

    return (
      <div {...rest}>
        <Checkbox
          disabled={disabled}
          checked={checked}
          onChange={handleChange}
        />
      </div>
    );
  }
)`
  .CheckboxInputFacade {
    margin-left: 8px;
  }
  label {
    margin: 0;
  }
`;

export const SetAllNone = styled(SetAllCheckbox)`
  grid-column: 1;
`;

export const SetAllView = styled(SetAllCheckbox)`
  grid-column: 2;
`;

export const SetAllEdit = styled(SetAllCheckbox)`
  grid-column: 3;
`;

export const SetAllRemove = styled(SetAllCheckbox)`
  grid-column: 4;
`;
